import { useQuery } from '@tanstack/react-query';
import {
  MerchantApiCredentialsService,
  MerchantCredentialResponseEntity,
} from 'services/openapi';
import { MerchantCredentialQueryKeys } from './constants';

export const useGetMerchantCredentialDetailQuery = (
  id: string,
  enabled = true,
) => {
  const queryKey = [
    MerchantCredentialQueryKeys.GET_MERCHANT_CREDENTIAL_DETAIL,
    id,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<MerchantCredentialResponseEntity, Error>({
    queryKey,
    queryFn: () =>
      MerchantApiCredentialsService.merchantApiControllerGetClientDetail(id),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: enabled && !!id,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
